import React, { useCallback } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { SubBtn } from './';
import { TYPE, URL } from '../../../constant';
import { useLearningBtn, useLearningData } from '../../../hooks';
import { useLastLocation } from 'react-router-last-location';

//학습진행 상태코드 - LPSC01: 노력, LPSC02: 기본, LPSC03: 충분, LPSC04: 훌륭
const { LPSC01 } = TYPE.LRN_PRGS_STS_CD;
const { LEARNING_NOTE, LIST } = URL.COURSE_LEARNING;

/**
 * 코스 > 학습중으로 진입 했을 경우만: 다음스테이지 학습하기 출력.
 * 학습노트로 집인 시: 버튼은 전부 미노출
 * 주제학습: 다음 스테이지 학습하기 버튼 출력 안됨.
 * 계속학습하기는 학습이 끝나고 결과화면과, 주제학습에서 소주제를 타고 들어 왔을 때 그때 상황이 노력일 때만 노출
 */
function ResultButtons({ result }) {
  const { t } = useTranslation();
  const LAST_PATH = sessionStorage.getItem('lastPath')
  const location = useLocation();
  const lastLocation = useLastLocation();
  const history = useHistory();
  const [goLearning] = useLearningBtn();
  const { setLearningData } = useLearningData();

  const handleClick = useCallback((type) => {
    let stgCd = result.stgCd;
    // 다음 스테이지 학습하기 일때
    if (type === 'next') {
      stgCd = result.nextStgCd;
      // 코스학습 완료 탭에서 진입 했을 경우만
      if (LAST_PATH === URL.COURSE_LEARNING.LIST || LAST_PATH === `${URL.COURSE_LEARNING.LIST}/tab1`) {
        // 다음 학습코드가 없을 시 완료 페이지로 이동
        if (!result.nextStgCd) {
          history.push(URL.COURSE_LEARNING.LIST);
          setLearningData({
            stgCd: result.stgCd
          });
          return;
        }
        
      }
    }

    handleGoLearningBtn({
      stage: stgCd,
      lrnEntyScnCd: location.state?.lrnEntyScnCd,
      type: 'replace',
    });

  }, [result, location]);

  const handleGoLearningBtn = useCallback(({stage, lrnEntyScnCd, type}) => {
    let learningEntryType = null;

    switch (lastLocation?.pathname) {
      case URL.PROGRESS_LEARNING.AI_BAROSEM:
        learningEntryType = TYPE.LEARNING_ENTRY.AIBRS;
        break;
      case URL.PROGRESS_LEARNING.MATHEMATICS:
        learningEntryType = TYPE.LEARNING_ENTRY.SBJTMATH;
        break;
      case URL.TOPIC_LEARNING:
        learningEntryType = TYPE.LEARNING_ENTRY.THMA;
        break;
    }

    goLearning({ stage, lrnEntyScnCd, type, learningEntryType });
  }, [])

  // 학습노트로 진입한 경우
  if (_.isEqual(LAST_PATH, LEARNING_NOTE)) return <></>
  return (
    <div className="footer grad footer-grad">
      <div className="footer-inner">
        {
          /**
           * 학습노트가 아닐 경우
           */
          (!_.isEqual(LAST_PATH, LEARNING_NOTE)
          ) && (
            // 학습결과가 노력일 경우
            _.isEqual(result.lrnPrgsStsCd, LPSC01) && (
              <button
                className="btn btn-red"
                onClick={() => handleClick('')}
              >{t("LC_05_07_01.msg020")}
              </button>
            )
          )
        }
        <div className="d-flex">
          <div className="d-item">
            <SubBtn
              result={result}
              className={"btn btn-sky"}
              lrnEntyScnCd={location.state?.lrnEntyScnCd}
              handleGoLearningBtn={handleGoLearningBtn}
            />
          </div>
            {
              // 코스학습 학습중에서 진입했을 경우
              ((_.isEqual(LAST_PATH, `${LIST}/tab1`)
                || _.isEqual(LAST_PATH, `${LIST}`)) 
                && !_.isEqual(result.lrnPrgsStsCd, LPSC01)) && (
                // 다음 스테이지가 있는 경우
                result.nextStgCd && (
                  <div className="d-item btnItem-auto">
                    <button
                      className="btn btn-blue"
                      onClick={() => handleClick('next')}
                    >
                    {t("LC_05_07_02.msg016")}
                      {/* 다음 스테이지 학습<span className="m-none">하기</span> */}
                    </button>
                  </div>
                )
              )
            }
        </div>
      </div>
    </div>
  );
}

export default ResultButtons;